<template>
  <b-card no-body class="vessel-stat w-100">
    <div slot="header">
      Stats
    </div>
    <b-card-body>
      <div v-if="isEmpty" class="text-center">
        No data available
      </div>
      <ul v-else class="stats">
        <li>
          <p>Imo:</p>
          <p>{{ getNested(stats, 'imo', '--') }}</p>
        </li>
        <li>
          <p>Vessel Name:</p>
          <p>{{ getNested(stats, 'name', '--') }}</p>
        </li>
        <li>
          <p>Ex Name:</p>
          <p>{{ statsComputed.exName }}</p>
        </li>
        <li>
          <p>Dwt:</p>
          <p>{{ statsComputed.dwt }}</p>
        </li>
        <li>
          <p>Built:</p>
          <p>{{ getNested(stats, 'built', '--') }}</p>
        </li>
        <li>
          <p>Destination:</p>
          <p>{{ statsComputed.destination }}</p>
        </li>
        <li>
          <p>Speed:</p>
          <p>{{ statsComputed.speed }}</p>
        </li>
        <li>
          <p>Draught:</p>
          <p>
            {{ statsComputed.draught }}m
            ({{ statsComputed.ladenPercent }} laden)
          </p>
        </li>
        <li>
          <p>Last updated received:</p>
          <p>
            {{ getNested(statsComputed, 'lastUpdate', '--') }}
          </p>
        </li>
      </ul>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment'
import getNested from 'lodash-es/get'
import { formatPercent, formatVolume } from '@/shared/number-utils'

export default {
  name: 'movements-stat',
  props: {
    stats: {
      type: Object,
      default: () => ({})
    },
    liveStats: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  methods: {
    getNested: getNested,

    formatDate(dateString) {
      if (dateString) {
        let ts = moment(dateString);
        let delta = ts.fromNow();
        return moment(dateString).format('YYYY-MM-DD HH:mm:ss') + ' (' + delta + ')';
      } else {
        return '--';
      }
    },

    getDestination(vessel) {
      const portName = getNested(vessel, 'state.destination.portName', null);
      const countryCode = getNested(vessel, 'state.destination.country', null);
      const unlocode = getNested(vessel, 'state.destination.unlocode', null);
      const region = getNested(vessel, 'state.destination.region', null);

      if (portName && unlocode) {
        return `${portName} (${unlocode}) - Region: ${region}`;
      }

      if (portName && countryCode) {
        return `${portName} (${countryCode}) - Region: ${region}`;
      }

      const rawDestination = getNested(
        vessel,
        'state.destination.raw_destination',
        null
      );
      if (rawDestination) {
        return rawDestination + ' (unparsed)';
      }

      const staticDestination = getNested(vessel, 'static.destination', '--');
      return `${staticDestination} (unparsed)`;
    },

    getLadenPercent(vessel) {
      let ladenPercent = getNested(vessel, 'state.ladenPercent', null);
      if (ladenPercent) {
        ladenPercent = ladenPercent <= 1 ? ladenPercent : 1;
        return formatPercent(ladenPercent);
      }

      const draught = getNested(vessel, 'static.draught', null);
      const maxDraught = getNested(vessel, 'vesselMasterdata.maxDraught', null);
      if (draught && maxDraught) {
        ladenPercent = draught / maxDraught
        ladenPercent = ladenPercent <= 1 ? ladenPercent : 1;
        return formatPercent(draught / maxDraught);
      }
      return '--';
    },
  },

  computed: {
    statsComputed: function () {
      if (this.stats && this.liveStats) {
        let stats = this.stats;
        return {
          ...stats,
          dwt: formatVolume(stats.dwt),
          ladenPercent: this.getLadenPercent(this.liveStats),
          destination: this.getDestination(this.liveStats),
          speed: getNested(this.liveStats, 'position.speed', '0'),
          draught: getNested(this.liveStats, 'static.draught', '0'),
          exName: getNested(stats, 'exName', '--') || '--',
          lastUpdate: this.formatDate(getNested(this.liveStats, 'position.timestamp'))
        };
      } else {
        return {
          dwt: '--',
          ladenPercent: '--',
          destination: '--',
          speed: '0',
          draught: '0',
          exName: '--',
          lastUpdate: '--',
        };
      }
    },
    isEmpty: function () {
      return !Object.keys(this.stats).length;
    }
  }
};
</script>

<style lang="scss" scoped>
.vessel-stat {
  min-height: 418px;
}

.stats {
  list-style: none;
  padding: 0;

  li {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    border-bottom: 1px solid gray;
    padding-bottom: 5px;
    margin-bottom: 20px;

    p:first-child {
      font-weight: 600;
    }
  }

  p {
    margin: 0;
  }
}
</style>
